import React, { ReactNode } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Stack } from 'components/Stack';
import { Text } from 'components/Text';
import {
  SixRecipesRoot,
  Recipe,
  RecipesContainer,
  SixRecipesContainer,
  IconWrapper
} from './SixRecipes.styles';
import { Icon } from 'components/Icon';
import Link from 'next/link';
import { Proteins } from 'models/Pet';
type IconName = "chicken" | "deer" | "cow" | "lamb" | "turkey" | "duck";

type RecipePillProps = {
  recipe: Proteins;
  icon: IconName;
  children: ReactNode;
  large?: boolean;
}

export const RecipePill = ({ recipe, icon, children, large = false }: RecipePillProps) => {
  return (
    <Link href={`/recipes/${recipe.toLowerCase()}`}>
      <Recipe large={large} type={recipe}>
        <IconWrapper large={large}>
          <Icon size="5" name={icon} />
        </IconWrapper>
        <Text
          weight="regular"
          css={{ width: '100%' }}
          align="center"
          size="h5"
          color="accent-white"
        >
          {children}
        </Text>
      </Recipe>
    </Link>
  );
}

export const SixRecipes = () => {
  const { t } = useTranslation();

  return (
    <SixRecipesRoot>
      <SixRecipesContainer>
        <Stack alignItems='center' justifyContent='center'>
          <Text align="center" size="h4" color="accent-black" weight="bold">
            {t('recipes:overview.six-recipes.title')}
          </Text>
        </Stack>
        <RecipesContainer>
          <RecipePill recipe={Proteins.CHICKEN} icon="chicken">
            {t('recipes:overview.six-recipes.recipe-1')}
          </RecipePill>
          <RecipePill recipe={Proteins.BEEF} icon="cow">
            {t('recipes:overview.six-recipes.recipe-2')}
          </RecipePill>
          <RecipePill recipe={Proteins.LAMB} icon="lamb">
            {t('recipes:overview.six-recipes.recipe-3')}
          </RecipePill>
          <RecipePill recipe={Proteins.TURKEY} icon="turkey">
            {t('recipes:overview.six-recipes.recipe-4')}
          </RecipePill>
          <RecipePill recipe={Proteins.VENISON} icon="deer">
            {t('recipes:overview.six-recipes.recipe-5')}
          </RecipePill>
          <RecipePill recipe={Proteins.DUCK} icon="duck">
            {t('recipes:overview.six-recipes.recipe-6')}
          </RecipePill>
        </RecipesContainer>
      </SixRecipesContainer>
    </SixRecipesRoot>
  );
}

SixRecipes.displayName = 'SixRecipes';
